package com.eladfinish.bible.contest

import dev.icerock.moko.resources.AssetResource
import kotlin.collections.List

internal object CommonMainAssets13 {
  internal val _36_ezra_02_txt: AssetResource by lazy { init__36_ezra_02_txt() }

  internal val _36_ezra_03_txt: AssetResource by lazy { init__36_ezra_03_txt() }

  internal val _36_ezra_04_txt: AssetResource by lazy { init__36_ezra_04_txt() }

  internal val _36_ezra_05_txt: AssetResource by lazy { init__36_ezra_05_txt() }

  internal val _36_ezra_06_txt: AssetResource by lazy { init__36_ezra_06_txt() }

  internal val _36_ezra_07_txt: AssetResource by lazy { init__36_ezra_07_txt() }

  internal val _36_ezra_08_txt: AssetResource by lazy { init__36_ezra_08_txt() }

  internal val _36_ezra_09_txt: AssetResource by lazy { init__36_ezra_09_txt() }

  internal val _36_ezra_10_txt: AssetResource by lazy { init__36_ezra_10_txt() }

  internal val _37_nechemia_01_txt: AssetResource by lazy { init__37_nechemia_01_txt() }

  internal val _37_nechemia_02_txt: AssetResource by lazy { init__37_nechemia_02_txt() }

  internal val _37_nechemia_03_txt: AssetResource by lazy { init__37_nechemia_03_txt() }

  internal val _37_nechemia_04_txt: AssetResource by lazy { init__37_nechemia_04_txt() }

  internal val _37_nechemia_05_txt: AssetResource by lazy { init__37_nechemia_05_txt() }

  internal val _37_nechemia_06_txt: AssetResource by lazy { init__37_nechemia_06_txt() }

  internal val _37_nechemia_07_txt: AssetResource by lazy { init__37_nechemia_07_txt() }

  internal val _37_nechemia_08_txt: AssetResource by lazy { init__37_nechemia_08_txt() }

  internal val _37_nechemia_09_txt: AssetResource by lazy { init__37_nechemia_09_txt() }

  internal val _37_nechemia_10_txt: AssetResource by lazy { init__37_nechemia_10_txt() }

  internal val _37_nechemia_11_txt: AssetResource by lazy { init__37_nechemia_11_txt() }

  internal val _37_nechemia_12_txt: AssetResource by lazy { init__37_nechemia_12_txt() }

  internal val _37_nechemia_13_txt: AssetResource by lazy { init__37_nechemia_13_txt() }

  internal val _38_divrei_hayamim_a_01_txt: AssetResource by lazy {
      init__38_divrei_hayamim_a_01_txt() }

  internal val _38_divrei_hayamim_a_02_txt: AssetResource by lazy {
      init__38_divrei_hayamim_a_02_txt() }

  internal val _38_divrei_hayamim_a_03_txt: AssetResource by lazy {
      init__38_divrei_hayamim_a_03_txt() }

  internal val _38_divrei_hayamim_a_04_txt: AssetResource by lazy {
      init__38_divrei_hayamim_a_04_txt() }

  internal val _38_divrei_hayamim_a_05_txt: AssetResource by lazy {
      init__38_divrei_hayamim_a_05_txt() }

  internal val _38_divrei_hayamim_a_06_txt: AssetResource by lazy {
      init__38_divrei_hayamim_a_06_txt() }

  internal val _38_divrei_hayamim_a_07_txt: AssetResource by lazy {
      init__38_divrei_hayamim_a_07_txt() }

  internal val _38_divrei_hayamim_a_08_txt: AssetResource by lazy {
      init__38_divrei_hayamim_a_08_txt() }

  internal val _38_divrei_hayamim_a_09_txt: AssetResource by lazy {
      init__38_divrei_hayamim_a_09_txt() }

  internal val _38_divrei_hayamim_a_10_txt: AssetResource by lazy {
      init__38_divrei_hayamim_a_10_txt() }

  internal val _38_divrei_hayamim_a_11_txt: AssetResource by lazy {
      init__38_divrei_hayamim_a_11_txt() }

  internal val _38_divrei_hayamim_a_12_txt: AssetResource by lazy {
      init__38_divrei_hayamim_a_12_txt() }

  internal val _38_divrei_hayamim_a_13_txt: AssetResource by lazy {
      init__38_divrei_hayamim_a_13_txt() }

  internal val _38_divrei_hayamim_a_14_txt: AssetResource by lazy {
      init__38_divrei_hayamim_a_14_txt() }

  internal val _38_divrei_hayamim_a_15_txt: AssetResource by lazy {
      init__38_divrei_hayamim_a_15_txt() }

  internal val _38_divrei_hayamim_a_16_txt: AssetResource by lazy {
      init__38_divrei_hayamim_a_16_txt() }

  internal val _38_divrei_hayamim_a_17_txt: AssetResource by lazy {
      init__38_divrei_hayamim_a_17_txt() }

  internal val _38_divrei_hayamim_a_18_txt: AssetResource by lazy {
      init__38_divrei_hayamim_a_18_txt() }

  internal val _38_divrei_hayamim_a_19_txt: AssetResource by lazy {
      init__38_divrei_hayamim_a_19_txt() }

  internal val _38_divrei_hayamim_a_20_txt: AssetResource by lazy {
      init__38_divrei_hayamim_a_20_txt() }

  internal val _38_divrei_hayamim_a_21_txt: AssetResource by lazy {
      init__38_divrei_hayamim_a_21_txt() }

  internal val _38_divrei_hayamim_a_22_txt: AssetResource by lazy {
      init__38_divrei_hayamim_a_22_txt() }

  internal val _38_divrei_hayamim_a_23_txt: AssetResource by lazy {
      init__38_divrei_hayamim_a_23_txt() }

  internal val _38_divrei_hayamim_a_24_txt: AssetResource by lazy {
      init__38_divrei_hayamim_a_24_txt() }

  internal val _38_divrei_hayamim_a_25_txt: AssetResource by lazy {
      init__38_divrei_hayamim_a_25_txt() }

  internal val _38_divrei_hayamim_a_26_txt: AssetResource by lazy {
      init__38_divrei_hayamim_a_26_txt() }

  internal val _38_divrei_hayamim_a_27_txt: AssetResource by lazy {
      init__38_divrei_hayamim_a_27_txt() }

  internal val _38_divrei_hayamim_a_28_txt: AssetResource by lazy {
      init__38_divrei_hayamim_a_28_txt() }

  internal fun values(): List<AssetResource> = listOf(_36_ezra_02_txt, _36_ezra_03_txt,
      _36_ezra_04_txt, _36_ezra_05_txt, _36_ezra_06_txt, _36_ezra_07_txt, _36_ezra_08_txt,
      _36_ezra_09_txt, _36_ezra_10_txt, _37_nechemia_01_txt, _37_nechemia_02_txt,
      _37_nechemia_03_txt, _37_nechemia_04_txt, _37_nechemia_05_txt, _37_nechemia_06_txt,
      _37_nechemia_07_txt, _37_nechemia_08_txt, _37_nechemia_09_txt, _37_nechemia_10_txt,
      _37_nechemia_11_txt, _37_nechemia_12_txt, _37_nechemia_13_txt, _38_divrei_hayamim_a_01_txt,
      _38_divrei_hayamim_a_02_txt, _38_divrei_hayamim_a_03_txt, _38_divrei_hayamim_a_04_txt,
      _38_divrei_hayamim_a_05_txt, _38_divrei_hayamim_a_06_txt, _38_divrei_hayamim_a_07_txt,
      _38_divrei_hayamim_a_08_txt, _38_divrei_hayamim_a_09_txt, _38_divrei_hayamim_a_10_txt,
      _38_divrei_hayamim_a_11_txt, _38_divrei_hayamim_a_12_txt, _38_divrei_hayamim_a_13_txt,
      _38_divrei_hayamim_a_14_txt, _38_divrei_hayamim_a_15_txt, _38_divrei_hayamim_a_16_txt,
      _38_divrei_hayamim_a_17_txt, _38_divrei_hayamim_a_18_txt, _38_divrei_hayamim_a_19_txt,
      _38_divrei_hayamim_a_20_txt, _38_divrei_hayamim_a_21_txt, _38_divrei_hayamim_a_22_txt,
      _38_divrei_hayamim_a_23_txt, _38_divrei_hayamim_a_24_txt, _38_divrei_hayamim_a_25_txt,
      _38_divrei_hayamim_a_26_txt, _38_divrei_hayamim_a_27_txt, _38_divrei_hayamim_a_28_txt)
}

private fun init__36_ezra_02_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_36_ezra-02.txt\")") as String, rawPath =
    "allChapters/_36_ezra-02.txt")

private fun init__36_ezra_03_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_36_ezra-03.txt\")") as String, rawPath =
    "allChapters/_36_ezra-03.txt")

private fun init__36_ezra_04_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_36_ezra-04.txt\")") as String, rawPath =
    "allChapters/_36_ezra-04.txt")

private fun init__36_ezra_05_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_36_ezra-05.txt\")") as String, rawPath =
    "allChapters/_36_ezra-05.txt")

private fun init__36_ezra_06_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_36_ezra-06.txt\")") as String, rawPath =
    "allChapters/_36_ezra-06.txt")

private fun init__36_ezra_07_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_36_ezra-07.txt\")") as String, rawPath =
    "allChapters/_36_ezra-07.txt")

private fun init__36_ezra_08_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_36_ezra-08.txt\")") as String, rawPath =
    "allChapters/_36_ezra-08.txt")

private fun init__36_ezra_09_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_36_ezra-09.txt\")") as String, rawPath =
    "allChapters/_36_ezra-09.txt")

private fun init__36_ezra_10_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_36_ezra-10.txt\")") as String, rawPath =
    "allChapters/_36_ezra-10.txt")

private fun init__37_nechemia_01_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_37_nechemia-01.txt\")") as String, rawPath =
    "allChapters/_37_nechemia-01.txt")

private fun init__37_nechemia_02_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_37_nechemia-02.txt\")") as String, rawPath =
    "allChapters/_37_nechemia-02.txt")

private fun init__37_nechemia_03_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_37_nechemia-03.txt\")") as String, rawPath =
    "allChapters/_37_nechemia-03.txt")

private fun init__37_nechemia_04_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_37_nechemia-04.txt\")") as String, rawPath =
    "allChapters/_37_nechemia-04.txt")

private fun init__37_nechemia_05_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_37_nechemia-05.txt\")") as String, rawPath =
    "allChapters/_37_nechemia-05.txt")

private fun init__37_nechemia_06_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_37_nechemia-06.txt\")") as String, rawPath =
    "allChapters/_37_nechemia-06.txt")

private fun init__37_nechemia_07_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_37_nechemia-07.txt\")") as String, rawPath =
    "allChapters/_37_nechemia-07.txt")

private fun init__37_nechemia_08_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_37_nechemia-08.txt\")") as String, rawPath =
    "allChapters/_37_nechemia-08.txt")

private fun init__37_nechemia_09_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_37_nechemia-09.txt\")") as String, rawPath =
    "allChapters/_37_nechemia-09.txt")

private fun init__37_nechemia_10_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_37_nechemia-10.txt\")") as String, rawPath =
    "allChapters/_37_nechemia-10.txt")

private fun init__37_nechemia_11_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_37_nechemia-11.txt\")") as String, rawPath =
    "allChapters/_37_nechemia-11.txt")

private fun init__37_nechemia_12_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_37_nechemia-12.txt\")") as String, rawPath =
    "allChapters/_37_nechemia-12.txt")

private fun init__37_nechemia_13_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_37_nechemia-13.txt\")") as String, rawPath =
    "allChapters/_37_nechemia-13.txt")

private fun init__38_divrei_hayamim_a_01_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_38_divrei_hayamim_a-01.txt\")") as String, rawPath =
    "allChapters/_38_divrei_hayamim_a-01.txt")

private fun init__38_divrei_hayamim_a_02_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_38_divrei_hayamim_a-02.txt\")") as String, rawPath =
    "allChapters/_38_divrei_hayamim_a-02.txt")

private fun init__38_divrei_hayamim_a_03_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_38_divrei_hayamim_a-03.txt\")") as String, rawPath =
    "allChapters/_38_divrei_hayamim_a-03.txt")

private fun init__38_divrei_hayamim_a_04_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_38_divrei_hayamim_a-04.txt\")") as String, rawPath =
    "allChapters/_38_divrei_hayamim_a-04.txt")

private fun init__38_divrei_hayamim_a_05_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_38_divrei_hayamim_a-05.txt\")") as String, rawPath =
    "allChapters/_38_divrei_hayamim_a-05.txt")

private fun init__38_divrei_hayamim_a_06_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_38_divrei_hayamim_a-06.txt\")") as String, rawPath =
    "allChapters/_38_divrei_hayamim_a-06.txt")

private fun init__38_divrei_hayamim_a_07_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_38_divrei_hayamim_a-07.txt\")") as String, rawPath =
    "allChapters/_38_divrei_hayamim_a-07.txt")

private fun init__38_divrei_hayamim_a_08_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_38_divrei_hayamim_a-08.txt\")") as String, rawPath =
    "allChapters/_38_divrei_hayamim_a-08.txt")

private fun init__38_divrei_hayamim_a_09_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_38_divrei_hayamim_a-09.txt\")") as String, rawPath =
    "allChapters/_38_divrei_hayamim_a-09.txt")

private fun init__38_divrei_hayamim_a_10_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_38_divrei_hayamim_a-10.txt\")") as String, rawPath =
    "allChapters/_38_divrei_hayamim_a-10.txt")

private fun init__38_divrei_hayamim_a_11_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_38_divrei_hayamim_a-11.txt\")") as String, rawPath =
    "allChapters/_38_divrei_hayamim_a-11.txt")

private fun init__38_divrei_hayamim_a_12_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_38_divrei_hayamim_a-12.txt\")") as String, rawPath =
    "allChapters/_38_divrei_hayamim_a-12.txt")

private fun init__38_divrei_hayamim_a_13_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_38_divrei_hayamim_a-13.txt\")") as String, rawPath =
    "allChapters/_38_divrei_hayamim_a-13.txt")

private fun init__38_divrei_hayamim_a_14_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_38_divrei_hayamim_a-14.txt\")") as String, rawPath =
    "allChapters/_38_divrei_hayamim_a-14.txt")

private fun init__38_divrei_hayamim_a_15_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_38_divrei_hayamim_a-15.txt\")") as String, rawPath =
    "allChapters/_38_divrei_hayamim_a-15.txt")

private fun init__38_divrei_hayamim_a_16_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_38_divrei_hayamim_a-16.txt\")") as String, rawPath =
    "allChapters/_38_divrei_hayamim_a-16.txt")

private fun init__38_divrei_hayamim_a_17_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_38_divrei_hayamim_a-17.txt\")") as String, rawPath =
    "allChapters/_38_divrei_hayamim_a-17.txt")

private fun init__38_divrei_hayamim_a_18_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_38_divrei_hayamim_a-18.txt\")") as String, rawPath =
    "allChapters/_38_divrei_hayamim_a-18.txt")

private fun init__38_divrei_hayamim_a_19_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_38_divrei_hayamim_a-19.txt\")") as String, rawPath =
    "allChapters/_38_divrei_hayamim_a-19.txt")

private fun init__38_divrei_hayamim_a_20_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_38_divrei_hayamim_a-20.txt\")") as String, rawPath =
    "allChapters/_38_divrei_hayamim_a-20.txt")

private fun init__38_divrei_hayamim_a_21_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_38_divrei_hayamim_a-21.txt\")") as String, rawPath =
    "allChapters/_38_divrei_hayamim_a-21.txt")

private fun init__38_divrei_hayamim_a_22_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_38_divrei_hayamim_a-22.txt\")") as String, rawPath =
    "allChapters/_38_divrei_hayamim_a-22.txt")

private fun init__38_divrei_hayamim_a_23_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_38_divrei_hayamim_a-23.txt\")") as String, rawPath =
    "allChapters/_38_divrei_hayamim_a-23.txt")

private fun init__38_divrei_hayamim_a_24_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_38_divrei_hayamim_a-24.txt\")") as String, rawPath =
    "allChapters/_38_divrei_hayamim_a-24.txt")

private fun init__38_divrei_hayamim_a_25_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_38_divrei_hayamim_a-25.txt\")") as String, rawPath =
    "allChapters/_38_divrei_hayamim_a-25.txt")

private fun init__38_divrei_hayamim_a_26_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_38_divrei_hayamim_a-26.txt\")") as String, rawPath =
    "allChapters/_38_divrei_hayamim_a-26.txt")

private fun init__38_divrei_hayamim_a_27_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_38_divrei_hayamim_a-27.txt\")") as String, rawPath =
    "allChapters/_38_divrei_hayamim_a-27.txt")

private fun init__38_divrei_hayamim_a_28_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_38_divrei_hayamim_a-28.txt\")") as String, rawPath =
    "allChapters/_38_divrei_hayamim_a-28.txt")

public actual val SharedRes.assets.allChapters._36_ezra_02_txt: AssetResource
  get() = CommonMainAssets13._36_ezra_02_txt

public actual val SharedRes.assets.allChapters._36_ezra_03_txt: AssetResource
  get() = CommonMainAssets13._36_ezra_03_txt

public actual val SharedRes.assets.allChapters._36_ezra_04_txt: AssetResource
  get() = CommonMainAssets13._36_ezra_04_txt

public actual val SharedRes.assets.allChapters._36_ezra_05_txt: AssetResource
  get() = CommonMainAssets13._36_ezra_05_txt

public actual val SharedRes.assets.allChapters._36_ezra_06_txt: AssetResource
  get() = CommonMainAssets13._36_ezra_06_txt

public actual val SharedRes.assets.allChapters._36_ezra_07_txt: AssetResource
  get() = CommonMainAssets13._36_ezra_07_txt

public actual val SharedRes.assets.allChapters._36_ezra_08_txt: AssetResource
  get() = CommonMainAssets13._36_ezra_08_txt

public actual val SharedRes.assets.allChapters._36_ezra_09_txt: AssetResource
  get() = CommonMainAssets13._36_ezra_09_txt

public actual val SharedRes.assets.allChapters._36_ezra_10_txt: AssetResource
  get() = CommonMainAssets13._36_ezra_10_txt

public actual val SharedRes.assets.allChapters._37_nechemia_01_txt: AssetResource
  get() = CommonMainAssets13._37_nechemia_01_txt

public actual val SharedRes.assets.allChapters._37_nechemia_02_txt: AssetResource
  get() = CommonMainAssets13._37_nechemia_02_txt

public actual val SharedRes.assets.allChapters._37_nechemia_03_txt: AssetResource
  get() = CommonMainAssets13._37_nechemia_03_txt

public actual val SharedRes.assets.allChapters._37_nechemia_04_txt: AssetResource
  get() = CommonMainAssets13._37_nechemia_04_txt

public actual val SharedRes.assets.allChapters._37_nechemia_05_txt: AssetResource
  get() = CommonMainAssets13._37_nechemia_05_txt

public actual val SharedRes.assets.allChapters._37_nechemia_06_txt: AssetResource
  get() = CommonMainAssets13._37_nechemia_06_txt

public actual val SharedRes.assets.allChapters._37_nechemia_07_txt: AssetResource
  get() = CommonMainAssets13._37_nechemia_07_txt

public actual val SharedRes.assets.allChapters._37_nechemia_08_txt: AssetResource
  get() = CommonMainAssets13._37_nechemia_08_txt

public actual val SharedRes.assets.allChapters._37_nechemia_09_txt: AssetResource
  get() = CommonMainAssets13._37_nechemia_09_txt

public actual val SharedRes.assets.allChapters._37_nechemia_10_txt: AssetResource
  get() = CommonMainAssets13._37_nechemia_10_txt

public actual val SharedRes.assets.allChapters._37_nechemia_11_txt: AssetResource
  get() = CommonMainAssets13._37_nechemia_11_txt

public actual val SharedRes.assets.allChapters._37_nechemia_12_txt: AssetResource
  get() = CommonMainAssets13._37_nechemia_12_txt

public actual val SharedRes.assets.allChapters._37_nechemia_13_txt: AssetResource
  get() = CommonMainAssets13._37_nechemia_13_txt

public actual val SharedRes.assets.allChapters._38_divrei_hayamim_a_01_txt: AssetResource
  get() = CommonMainAssets13._38_divrei_hayamim_a_01_txt

public actual val SharedRes.assets.allChapters._38_divrei_hayamim_a_02_txt: AssetResource
  get() = CommonMainAssets13._38_divrei_hayamim_a_02_txt

public actual val SharedRes.assets.allChapters._38_divrei_hayamim_a_03_txt: AssetResource
  get() = CommonMainAssets13._38_divrei_hayamim_a_03_txt

public actual val SharedRes.assets.allChapters._38_divrei_hayamim_a_04_txt: AssetResource
  get() = CommonMainAssets13._38_divrei_hayamim_a_04_txt

public actual val SharedRes.assets.allChapters._38_divrei_hayamim_a_05_txt: AssetResource
  get() = CommonMainAssets13._38_divrei_hayamim_a_05_txt

public actual val SharedRes.assets.allChapters._38_divrei_hayamim_a_06_txt: AssetResource
  get() = CommonMainAssets13._38_divrei_hayamim_a_06_txt

public actual val SharedRes.assets.allChapters._38_divrei_hayamim_a_07_txt: AssetResource
  get() = CommonMainAssets13._38_divrei_hayamim_a_07_txt

public actual val SharedRes.assets.allChapters._38_divrei_hayamim_a_08_txt: AssetResource
  get() = CommonMainAssets13._38_divrei_hayamim_a_08_txt

public actual val SharedRes.assets.allChapters._38_divrei_hayamim_a_09_txt: AssetResource
  get() = CommonMainAssets13._38_divrei_hayamim_a_09_txt

public actual val SharedRes.assets.allChapters._38_divrei_hayamim_a_10_txt: AssetResource
  get() = CommonMainAssets13._38_divrei_hayamim_a_10_txt

public actual val SharedRes.assets.allChapters._38_divrei_hayamim_a_11_txt: AssetResource
  get() = CommonMainAssets13._38_divrei_hayamim_a_11_txt

public actual val SharedRes.assets.allChapters._38_divrei_hayamim_a_12_txt: AssetResource
  get() = CommonMainAssets13._38_divrei_hayamim_a_12_txt

public actual val SharedRes.assets.allChapters._38_divrei_hayamim_a_13_txt: AssetResource
  get() = CommonMainAssets13._38_divrei_hayamim_a_13_txt

public actual val SharedRes.assets.allChapters._38_divrei_hayamim_a_14_txt: AssetResource
  get() = CommonMainAssets13._38_divrei_hayamim_a_14_txt

public actual val SharedRes.assets.allChapters._38_divrei_hayamim_a_15_txt: AssetResource
  get() = CommonMainAssets13._38_divrei_hayamim_a_15_txt

public actual val SharedRes.assets.allChapters._38_divrei_hayamim_a_16_txt: AssetResource
  get() = CommonMainAssets13._38_divrei_hayamim_a_16_txt

public actual val SharedRes.assets.allChapters._38_divrei_hayamim_a_17_txt: AssetResource
  get() = CommonMainAssets13._38_divrei_hayamim_a_17_txt

public actual val SharedRes.assets.allChapters._38_divrei_hayamim_a_18_txt: AssetResource
  get() = CommonMainAssets13._38_divrei_hayamim_a_18_txt

public actual val SharedRes.assets.allChapters._38_divrei_hayamim_a_19_txt: AssetResource
  get() = CommonMainAssets13._38_divrei_hayamim_a_19_txt

public actual val SharedRes.assets.allChapters._38_divrei_hayamim_a_20_txt: AssetResource
  get() = CommonMainAssets13._38_divrei_hayamim_a_20_txt

public actual val SharedRes.assets.allChapters._38_divrei_hayamim_a_21_txt: AssetResource
  get() = CommonMainAssets13._38_divrei_hayamim_a_21_txt

public actual val SharedRes.assets.allChapters._38_divrei_hayamim_a_22_txt: AssetResource
  get() = CommonMainAssets13._38_divrei_hayamim_a_22_txt

public actual val SharedRes.assets.allChapters._38_divrei_hayamim_a_23_txt: AssetResource
  get() = CommonMainAssets13._38_divrei_hayamim_a_23_txt

public actual val SharedRes.assets.allChapters._38_divrei_hayamim_a_24_txt: AssetResource
  get() = CommonMainAssets13._38_divrei_hayamim_a_24_txt

public actual val SharedRes.assets.allChapters._38_divrei_hayamim_a_25_txt: AssetResource
  get() = CommonMainAssets13._38_divrei_hayamim_a_25_txt

public actual val SharedRes.assets.allChapters._38_divrei_hayamim_a_26_txt: AssetResource
  get() = CommonMainAssets13._38_divrei_hayamim_a_26_txt

public actual val SharedRes.assets.allChapters._38_divrei_hayamim_a_27_txt: AssetResource
  get() = CommonMainAssets13._38_divrei_hayamim_a_27_txt

public actual val SharedRes.assets.allChapters._38_divrei_hayamim_a_28_txt: AssetResource
  get() = CommonMainAssets13._38_divrei_hayamim_a_28_txt
